<ng-container [formGroup]="submitForm">
  <mat-form-field>
    <mat-label>{{ 'contact-data-form.text.email' | translate }}</mat-label>
    <input
      [formControlName]="FORM_NAME.EMAIL"
      matInput
      name="email"
      type="email"
      [autocomplete]="'off'"
    />
    <mat-error>
      <lib-error-message-wrapper
        [control]="controlEmail"
      ></lib-error-message-wrapper>
    </mat-error>
  </mat-form-field>

  <lib-spacer></lib-spacer>

  <lib-phone-number-input
    [formControlName]="FORM_NAME.PHONE_NUMBER"
  ></lib-phone-number-input>
</ng-container>
